/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/User/Active/Post
 * @desc Active filter component for user
 */

import type { FilterPostActiveLabelProps } from 'labstep-web/components/FilterPost/Active/Label/types';
import { FilterPostNewIndexUserActiveLabel } from 'labstep-web/components/FilterPost/NewIndex/User/Active/Label';
import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { User } from 'labstep-web/models/user.model';
import type React from 'react';
import { getAuthorOrAssigneeGuid } from './utils';

export const FilterPostNewIndexUserActivePost: React.FC<
  FilterPostActiveLabelProps
> = ({ node, onRemoveClick }) => {
  const { guid, type } = getAuthorOrAssigneeGuid(node);
  if (!guid) {
    return null;
  }
  return (
    <EntityReadEntityContainer
      entityName={User.entityName}
      guid={guid}
    >
      {({ entity }): React.ReactElement | null =>
        entity ? (
          <FilterPostNewIndexUserActiveLabel
            user={entity}
            onRemoveClick={onRemoveClick}
            type={type}
          />
        ) : null
      }
    </EntityReadEntityContainer>
  );
};
